export enum WireComponentKind {
    Button = "page-button",
    Hint = "page-hint",
    TextField = "text-field",
    NumberField = "number-field",
    EmailField = "email-field",
    PhoneField = "phone-field",
    DateTimeField = "date-field",
    FilePicker = "file-picker",
    ImagePicker = "image-picker",
    Switch = "switch",
    Hero = "hero",
    ContactForm = "contact-form",
    DynamicButtonBar = "dynamic-button-bar",
    List = "list",
    Container = "container",
    Fields = "fields",
    Breadcrumbs = "breadcrumbs",
    RichText = "page-rich-text",
    Image = "page-image",
    Video = "page-video",
    Separator = "page-separator",
    SignIn = "sign-in",
    Custom = "custom",
}
